<template lang="pug" src="./hero.pug"></template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  data () {
    return {
      swiperOption: {
        slidesPerView: 1,
        initialSlide: Math.floor(Math.random() * Math.floor(3)),
        spaceBetween: 0,
        effect: 'fade',
        loop: true,
        speed: 750,
        autoplay: {
          delay: 10000
        }
      }
    }
  },
  props: ['props'],
  components: {
    swiper,
    swiperSlide
  },
  mounted () {
    setTimeout(() => {
      this.$refs.text.classList += ' hero__text--slide'
    }, 550)
    console.log(this.swiperOption.initialSlide)
  }
}
</script>



// WEBPACK FOOTER //
// hero.vue?ad9aed5c